define('rebrush/components/ui/sections',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'text!./sections/templates/bar.html',
    'select2',
    'cartware/components/Holepunch'
], function(
    $,
    _,
    Component,
    BEM,
    BarTemplate,
    S2,
    holepunch
) {
    var BLOCK = 'sections';
    var barTemplate = _.template(BarTemplate, { imports: {$:$} });

    function Sections(block, hub) {
        this.block = BEM.block(block);
        this.list = this.block.getElements('list');
        this.sectionTitles = this.block.getElements('section-title');
        this.barSlot = $('#' + this.block.data('bar-target'));
        this.title = this.block.data('bar-title');
        this.affixTarget = this.barSlot;
        this.hub = hub;
        this.affixSwitchCallbacks = [];
        this.affixMode = null;

        if (!this.barSlot.length) {
            return;
        }

        this.initializeRendering();
        this.initializeEvents();
        this.initializeBottomAffix();
        // this.initializeTopAffix();

        holepunch.ready($.proxy(function(payload) {
            _.forEach(payload.block_titles || [], function (title, key) {
                $('[data-name-in-layout="' + key + '"]')
                    .parents('.' + BEM.buildElementClassname(BLOCK, 'section-content'))
                    .before('<dt class="' + BEM.buildElementClassname(BLOCK, 'section-title') + '" id="' + key + '">'
                            + '<div class="' + BEM.buildElementClassname(BLOCK, 'container') + '">'
                                + '<span>'
                                    + title
                                + '</span>'
                            + '</div>'
                        + '</dt>');
            });
            this.initializeRendering();
        }, this));

        this.onScroll();
    }

    Sections.prototype = {
        bar:    null,
        affixInstance: null,
        currentSectionId: null,

        initializeRendering: function() {
            this.sectionTitles = this.block.getElements('section-title');
            if (this.bar) {
                this.bar.off();
                this.bar.remove();
            }

            this.bar = $('<div />').html(barTemplate({ block: this }));
            this.barSlot.append(this.bar);
            this.transformSelects();
            this.onScroll();
        },

        initializeEvents: function() {
            $(document.body).on('click', '.' + BEM.buildElementClassname('sections-bar', 'section-item'), _.bind(this.onSectionItemClick, this));
            $(document.body).on('change', '.' + BEM.buildElementClassname('sections-bar', 'sections-select'), _.bind(this.onSectionSelectChange, this));
            $(document.body).on('click', 'a', _.bind(this.onLinkClick, this))
            $(window).on('scroll', _.throttle(_.bind(this.onScroll, this)));
            $(window).on('resize', _.throttle(_.bind(this.onResize, this)));
            this.hub.on('ui', _.bind(this.onUiChange, this));
            this.hub.on('gigaset.content.change', _.bind(this.onUiChange, this));
        },

        initializeBottomAffix: function() {
            var self = this;
            var placeHolder = $('<div class="pl1" />');
            var wasTop = true;
            var affixInstance = this.getAffixInstance();
            var affixOptions = {
                offset: {
                    top: null,
                    bottom: _.bind(function() {
                        return $(document.body).height()
                            - (this.block.offset().top - $.css(this.block.get(0), 'margin-top', ''));
                    }, this)
                }
            };
            var monitorAffixSwitch = _.bind(function() {
                // TODO share with below "top"
                var top = _.bind(function() {
                    return (this.block.offset().top - $.css(this.block.get(0), 'margin-top', ''))
                        - (this.affixTarget.height() + $.css(this.affixTarget.get(0), 'margin-bottom', ''));
                }, this);

                var offsetTop = top(affixInstance.$element);
                var scrollTop    = affixInstance.$target.scrollTop();

                if (scrollTop > offsetTop) {
                    affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
                    _.defer(_.bind(self.initializeTopAffix, self));
                    // setTimeout(_.bind(self.initializeTopAffix, self), 5000); // Deferred testing
                }
            }, this);

            // Prepare
            this.onAffixSwitch();

            this.affixTarget.addClass('mode-bottom');

            this.affixTarget.css({
                position: 'relative'
            });

            // affixInstance.affixed = 'top';

            if ('top' === this.affixMode) {
                affixInstance.affixed = 'top';
            }

            function onAffix(e) {
                var target = $(e.currentTarget),
                    targetHeight;

                if (wasTop) {
                    targetHeight = target.outerHeight(true);
                    placeHolder.height(targetHeight);
                }

                target.after(placeHolder);

                wasTop = false;
                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            function onAffixTop() {
                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            function onAffixBottom() {
                placeHolder.detach();
                affixInstance.$target.on('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            // Cleanup
            this.affixSwitchCallbacks.push(function() {
                this.affixTarget
                    .off('affix.bs.affix', onAffix)
                    .off('affixed-top.bs.affix', onAffixTop)
                    .off('affixed-bottom.bs.affix', onAffixBottom);

                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);

                placeHolder.remove();

                this.affixTarget.removeClass('mode-bottom');
            });

            this.affixTarget
                .on('affix.bs.affix', onAffix)
                .on('affixed-top.bs.affix', onAffixTop)
                .on('affixed-bottom.bs.affix', onAffixBottom);

            // Initiate
            if (affixInstance) {
                $.extend(affixInstance.options, affixOptions);
                affixInstance.checkPosition();
            } else {
                this.affixTarget.affix(affixOptions);
            }

            // monitorAffixSwitch();
            this.affixMode = 'bottom';
        },

        initializeTopAffix: function() {
            var self = this;
            var placeHolder = $('<div class="pl2" />');
            var placeHolderBottom = $('<div class="pl3" />');
            var wasTop = true;
            var affixInstance = this.getAffixInstance();
            var affixOptions = {
                offset: {
                    top: _.bind(function() {
                        return (this.block.offset().top - $.css(this.block.get(0), 'margin-top', ''))
                            - (this.affixTarget.height() + $.css(this.affixTarget.get(0), 'margin-bottom', ''));
                    }, this),
                    bottom: _.bind(function() {
                        return $(document.body).height()
                            // + affixInstance.$target.height()
                            - (this.block.offset().top + this.block.outerHeight(true))
                            - (
                                affixInstance.affixed == null
                                    ? this.affixTarget.outerHeight(true)
                                    : placeHolderBottom.outerHeight(true)
                            );
                    }, this)
                }
            };
            var monitorAffixSwitch = _.bind(function() {
                // TODO share with above "bottom"
                var bottom = _.bind(function() {
                    return $(document.body).height()
                        - (this.block.offset().top - $.css(this.block.get(0), 'margin-top', ''));
                }, this);

                var offsetBottom = bottom(affixInstance.$element);
                var scrollHeight = Math.max($(document).height(), $(document.body).height());

                var scrollTop    = affixInstance.$target.scrollTop();
                var targetHeight = affixInstance.$target.height();

                if (scrollTop + targetHeight < scrollHeight - offsetBottom) {
                    affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
                    self.initializeBottomAffix();
                    // _.defer(_.bind(self.initializeBottomAffix, self));
                }

            }, this);

            // Prepare
            this.onAffixSwitch();

            this.affixTarget.addClass('mode-top');

            // Special case, when the page loads with the window scrolled into 'bottom' but not below it
            (function() {
                var height       = affixInstance.$element.height();
                var offset       = affixOptions.offset;
                var offsetTop    = offset.top();
                var offsetBottom = offset.bottom();
                var scrollHeight = Math.max($(document).height(), $(document.body).height());

                if ('bottom' == affixInstance.getState(scrollHeight, height, offsetTop, offsetBottom)) {
                    var scrollTop    = affixInstance.$target.scrollTop();

                    if (scrollHeight - scrollTop > offsetBottom) {
                        affixInstance.affixed = 'top';
                    }
                }
            })();

            function onAffix(e) {
                var target = $(e.currentTarget),
                    targetHeight;

                if (wasTop) {
                    targetHeight = target.outerHeight(true);
                    placeHolder.height(targetHeight);
                    placeHolderBottom.height(targetHeight);
                }

                target.after(placeHolder);
                self.block.after(placeHolderBottom);

                wasTop = false;

                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            function onAffixTop() {
                wasTop = true;
                placeHolder.detach();
                // self.initializeBottomAffix();
                affixInstance.$target.on('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            function onAffixBottom() {
                placeHolder.detach();
                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);
            }

            // Cleanup
            this.affixSwitchCallbacks.push(function() {
                this.affixTarget.off('affix.bs.affix', onAffix);
                this.affixTarget.off('affixed-top.bs.affix', onAffixTop);
                this.affixTarget.off('affixed-bottom.bs.affix', onAffixBottom);

                affixInstance.$target.off('scroll.bs.affix.data-api', monitorAffixSwitch);

                placeHolder.remove();
                placeHolderBottom.remove();

                this.affixTarget.removeClass('mode-top');
            });

            this.affixTarget
                .on('affix.bs.affix', onAffix)
                .on('affixed-top.bs.affix', onAffixTop)
                .on('affixed-bottom.bs.affix', onAffixBottom);

            // Initiate
            if (affixInstance) {
                $.extend(affixInstance.options, affixOptions);
                affixInstance.checkPosition();
            } else {
                this.affixTarget.affix(affixOptions);
            }

            // monitorAffixSwitch();
            this.affixMode = 'top';
        },

        onAffixSwitch: function() {
            var affixInstance = this.getAffixInstance();

            this.affixTarget
                .removeClass('affix affix-top affix-bottom')
                .css({
                    top: '',
                    position: ''
                });

            if (affixInstance) {
                affixInstance.affixed      = null;
                affixInstance.unpin        = null;
                affixInstance.pinnedOffset = null;
            }

            _.forEach(this.affixSwitchCallbacks, _.bind(function(fn) {
                fn.call(this);
            }, this));

            this.affixSwitchCallbacks = [];
        },

        getAffixInstance: function() {
            if (!this.affixInstance) {
                this.affixTarget.affix();
                this.affixInstance = this.affixTarget.data('bs.affix');
            }

            return this.affixInstance;
        },

        onUiChange: function() {
            this.getAffixInstance().checkPositionWithEventLoop();
        },

        onResize: function() {
            this.getAffixInstance().checkPositionWithEventLoop();
        },

        onScroll: function() {
            var scrollHeight = $(window).scrollTop(),
                barHeight = this.bar.height(),
                targetSectionTitle = this.sectionTitles.first(),
                targetSectionId = 0;

            this.sectionTitles.each(function(i) {
                var sectionTitle = $(this),
                    offset = sectionTitle.offset();

                if ('none' === sectionTitle.css('display')) {
                    return;
                }

                if (offset.top < (scrollHeight + barHeight)) {
                    targetSectionTitle = sectionTitle;
                    targetSectionId = i;
                }
            });

            if (this.currentSectionId === targetSectionId) {
                return;
            }

            this.bar.find('.' + BEM.buildElementClassname('sections-bar', 'section-item')).each(function() {
                var item = $(this),
                    sectionId = item.data('section-id');

                // console.log(targetSectionId, sectionId, item);

                if (targetSectionId == sectionId) {
                    item.addClass('active');
                } else {
                    item.removeClass('active');
                }
            });

            var select = this.bar.find('.' + BEM.buildElementClassname('sections-bar', 'sections-select')),
                select2 = select.data('select2');

            select.val(targetSectionId);

            if (select2) {
                select2.dataAdapter.current(function (data) {
                    select2.trigger('selection:update', {
                        data: data
                    });
                });
            }

            this.currentSectionId = targetSectionId;
        },

        onLinkClick: function(e) {
            var link = $(e.currentTarget),
                href = link.attr('href'),
                hrefMatch = href.match(/^#(.*)$/),
                section = (hrefMatch && hrefMatch[1] !== '') ? $(this.sectionTitles.filter(hrefMatch[0])) : null;

            if (section && section.length) {
                e.preventDefault();
                this.gotoSection(section);
            }
        },

        onSectionItemClick: function(e) {
            var sectionItem = $(e.currentTarget),
                sectionId = sectionItem.data('section-id'),
                section = $(this.sectionTitles.get(sectionId));

            this.gotoSection(section);
        },

        onSectionSelectChange: function(e) {
            var select = $(e.currentTarget),
                sectionId = select.val(),
                section = $(this.sectionTitles.get(sectionId));

            this.gotoSection(section);
        },

        gotoSection: function(section) {
            $('html, body').animate({
                scrollTop: section.offset().top + $.css(section.get(0), 'padding-top', '') - this.bar.outerHeight() + 1 // +1 in order to jump into the section
            }, 300);
        },

        transformSelects: function() {
            $.fn.select2.amd.require(
                ['select2/utils', 'select2/dropdown', 'select2/dropdown/attachBody', 'select2/dropdown/closeOnSelect'],
                _.bind(function (Utils, Dropdown, AttachBody, CloseOnSelect) {
                    this.bar.find('.' + BEM.buildElementClassname('sections-bar', 'sections-select')).each(function() {
                        var select = $(this),
                            dropdownAdapter;

                        if (select.data('select2')) {
                            return;
                        }

                        dropdownAdapter = Utils.Decorate(Utils.Decorate(Dropdown, AttachBody), CloseOnSelect);

                        select.select2({
                            dropdownAdapter: dropdownAdapter,
                            width: null,
                            theme: 'sections-selector'
                        });

                        //select.on("change", function(e) {
                        //	//if ("undefined" === typeof e.originalEvent) {
                        //	if (e instanceof $.Event) {
                        //		triggerEvent(this, "change");
                        //	}
                        //});
                    });
                }, this)
            );
        }
    };

    return Component.create({
        $init: function() {
            var self = this;
            this.block = BEM.block(BLOCK);
            this.block.each(function() {
                new Sections(this, self.hub);
            });
        }
    });
});
